import styled, { keyframes } from "styled-components";
import img1 from "../../../../../assets/img/contactless.jpg";
import img2 from "../../../../../assets/img/contactless1.jpg";
import img3 from "../../../../../assets/img/image3.jpg";
import { blueColor, goldColor } from "../../../../styled/Theme";
import {
  BankOutlined,
  RiseOutlined,
  QrcodeOutlined,
  CarOutlined,
  ArrowRightOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";

// const products = [
//   {
//     id: "fees",
//     tag: "Government",
//     icon: <BankOutlined />,
//     title: "Pay Fees & Taxes",
//     headline: "Digitised Municipal Revenue",
//     description:
//       "Digitised payment of municipal and local government fees using IRAS PRNs.",
//     bullets: [
//       "Municipal & local government payments",
//       "IRAS PRN-based reconciliation",
//       "Instant confirmation & receipt",
//     ],
//     stat: { value: "100%", label: "Traceable" },
//     accentColor: blueColor,
//     image: img3,
//     size: "tall", // spans 2 rows on left
//     href: "#fees",
//   },
//   {
//     id: "financial",
//     tag: "SACCOs",
//     icon: <RiseOutlined />,
//     title: "Financial Services",
//     headline: "SACCO & Institution Payments",
//     description:
//       "Secure digital payments for SACCO contributions, loan repayments, and withdrawals.",
//     bullets: [
//       "SACCO deposits & repayments",
//       "Real-time balance updates",
//       "Digital receipts & audit logs",
//     ],
//     stat: { value: "360°", label: "Member view" },
//     accentColor: "#0ea5e9",
//     image: img2,
//     size: "normal",
//     href: "#financial",
//   },
//   {
//     id: "bills",
//     tag: "Utilities",
//     icon: <QrcodeOutlined />,
//     title: "Pay Bills",
//     headline: "Instant Bill Settlement",
//     description:
//       "Instant settlement of utility and institutional bills with full transparency.",
//     bullets: [
//       "Utilities & institutions",
//       "Real-time bill fetching",
//       "No queues or paperwork",
//     ],
//     stat: { value: "< 30s", label: "Per payment" },
//     accentColor: goldColor,
//     image: img1,
//     size: "normal",
//     href: "#bills",
//   },
//   {
//     id: "parking",
//     tag: "Municipalities",
//     icon: <CarOutlined />,
//     title: "Street Parking",
//     headline: "Cashless Parking Compliance",
//     description:
//       "Cashless street parking payments with real-time enforcement verification.",
//     bullets: [
//       "QR-based parking receipts",
//       "Real-time officer verification",
//       "Cashless & dispute-free",
//     ],
//     stat: { value: "0", label: "Cash disputes" },
//     accentColor: "#22c55e",
//     image: img2,
//     size: "wide", // spans 2 cols on bottom
//     href: "#parking",
//   },
// ];

export default function ProductsOverview() {
  return (
    <Wrapper>
      <Inner className="container">
        {/* ── Header row ── */}
        <HeaderRow>
          <HeaderLeft
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-delay="80"
          >
            <Eyebrow>
              <EyebrowDot />
              Products &amp; Services
            </Eyebrow>
            <PageTitle>
              Everything your organisation needs,
              <br />
              in <GoldWord>one platform.</GoldWord>
            </PageTitle>
          </HeaderLeft>

          <HeaderRight
            data-aos="fade-left"
            data-aos-duration="700"
            data-aos-delay="160"
          >
            <HeaderSubline>
              A unified digital payments platform for government, institutions,
              and everyday services — secure, traceable, and built for scale.
            </HeaderSubline>
            <HeaderMeta>
              <MetaBadge>
                <CheckCircleFilled /> ISO 27001 Certified
              </MetaBadge>
              <MetaBadge>
                <CheckCircleFilled /> Regulator Ready
              </MetaBadge>
              <MetaBadge>
                <CheckCircleFilled /> 99.9% Uptime
              </MetaBadge>
            </HeaderMeta>
          </HeaderRight>
        </HeaderRow>

        {/* ── Bento product grid ── */}
        <BentoGrid>
          {/* Card 1: tall (left, spans 2 rows) */}
          <ProductCard
            $size="tall"
            $accent={blueColor}
            data-aos="fade-right"
            data-aos-duration="750"
            data-aos-delay="200"
          >
            <CardImageWrap>
              <CardImage src={img3} alt="Pay Fees & Taxes" />
              <CardImageGrad $accent={blueColor} />
            </CardImageWrap>
            <CardBody>
              <CardTagRow>
                <CardTag $accent={blueColor}>
                  <BankOutlined /> Government
                </CardTag>
                <CardStat $accent={blueColor}>
                  <CardStatVal>100%</CardStatVal>
                  <CardStatLabel>Traceable</CardStatLabel>
                </CardStat>
              </CardTagRow>
              <CardTitle>Pay Fees &amp; Taxes</CardTitle>
              <CardDesc>
                Digitised payment of municipal and local government fees using
                IRAS PRNs — instant confirmation every time.
              </CardDesc>
              <CardBullets>
                {[
                  "Municipal & local government payments",
                  "IRAS PRN-based reconciliation",
                  "Instant confirmation & receipt",
                ].map((b, i) => (
                  <CardBullet key={i}>
                    <BulletDot $accent={blueColor} />
                    {b}
                  </CardBullet>
                ))}
              </CardBullets>
            </CardBody>
            <CardCta $accent={blueColor} href="#">
              View Details <ArrowRightOutlined />
            </CardCta>
          </ProductCard>

          {/* Card 2: normal top-right */}
          <ProductCard
            $size="normal"
            $accent="#0ea5e9"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-delay="280"
          >
            <CardImageWrap $short>
              <CardImage src={img2} alt="Financial Services" />
              <CardImageGrad $accent="#0ea5e9" />
            </CardImageWrap>
            <CardBody>
              <CardTagRow>
                <CardTag $accent="#0ea5e9">
                  <RiseOutlined /> SACCOs
                </CardTag>
                <CardStat $accent="#0ea5e9">
                  <CardStatVal>360°</CardStatVal>
                  <CardStatLabel>Member view</CardStatLabel>
                </CardStat>
              </CardTagRow>
              <CardTitle>Financial Services</CardTitle>
              <CardDesc>
                Secure digital payments for SACCO contributions, loan
                repayments, and withdrawals.
              </CardDesc>
              <CardBullets>
                {[
                  "SACCO deposits & repayments",
                  "Real-time balance updates",
                  "Digital receipts & audit logs",
                ].map((b, i) => (
                  <CardBullet key={i}>
                    <BulletDot $accent="#0ea5e9" />
                    {b}
                  </CardBullet>
                ))}
              </CardBullets>
            </CardBody>
            <CardCta $accent="#0ea5e9" href="#">
              View Details <ArrowRightOutlined />
            </CardCta>
          </ProductCard>

          {/* Card 3: normal bottom-right top */}
          <ProductCard
            $size="normal"
            $accent={goldColor}
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-delay="360"
          >
            <CardImageWrap $short>
              <CardImage src={img1} alt="Pay Bills" />
              <CardImageGrad $accent={goldColor} />
            </CardImageWrap>
            <CardBody>
              <CardTagRow>
                <CardTag $accent={goldColor}>
                  <QrcodeOutlined /> Utilities
                </CardTag>
                <CardStat $accent={goldColor}>
                  <CardStatVal>&lt;30s</CardStatVal>
                  <CardStatLabel>Per payment</CardStatLabel>
                </CardStat>
              </CardTagRow>
              <CardTitle>Pay Bills</CardTitle>
              <CardDesc>
                Instant settlement of utility and institutional bills with full
                transparency and a permanent audit trail.
              </CardDesc>
              <CardBullets>
                {[
                  "Utilities & institutions",
                  "Real-time bill fetching",
                  "No queues or paperwork",
                ].map((b, i) => (
                  <CardBullet key={i}>
                    <BulletDot $accent={goldColor} />
                    {b}
                  </CardBullet>
                ))}
              </CardBullets>
            </CardBody>
            <CardCta $accent={goldColor} href="#">
              View Details <ArrowRightOutlined />
            </CardCta>
          </ProductCard>

          {/* Card 4: wide (bottom, spans 2 cols) */}
          <ProductCard
            $size="wide"
            $accent="#22c55e"
            data-aos="fade-up"
            data-aos-duration="750"
            data-aos-delay="440"
          >
            <WideCardInner>
              <WideImageWrap>
                <CardImage src={img2} alt="Street Parking" />
                <CardImageGrad $accent="#22c55e" />
                <WideOverlayBadge>
                  <BadgePulse />
                  Live enforcement
                </WideOverlayBadge>
              </WideImageWrap>
              <WideContent>
                <CardTagRow>
                  <CardTag $accent="#22c55e">
                    <CarOutlined /> Municipalities
                  </CardTag>
                  <CardStat $accent="#22c55e">
                    <CardStatVal>0</CardStatVal>
                    <CardStatLabel>Cash disputes</CardStatLabel>
                  </CardStat>
                </CardTagRow>
                <CardTitle>Street Parking</CardTitle>
                <CardDesc>
                  Cashless street parking with real-time enforcement
                  verification, QR receipts, and full municipal revenue
                  accountability.
                </CardDesc>
                <WideBulletGrid>
                  {[
                    "QR-based parking receipts",
                    "Real-time officer verification",
                    "Cashless & dispute-free",
                    "Municipal revenue secured",
                  ].map((b, i) => (
                    <CardBullet key={i}>
                      <BulletDot $accent="#22c55e" />
                      {b}
                    </CardBullet>
                  ))}
                </WideBulletGrid>
                <CardCta
                  $accent="#22c55e"
                  href="#"
                  style={{ display: "inline-flex", marginTop: "auto" }}
                >
                  View Details <ArrowRightOutlined />
                </CardCta>
              </WideContent>
            </WideCardInner>
          </ProductCard>
        </BentoGrid>
      </Inner>
    </Wrapper>
  );
}

/* ── Animations ── */
const pulse = keyframes`
  0%, 100% { box-shadow: 0 0 0 0 rgba(34,197,94,0.5); }
  50%       { box-shadow: 0 0 0 7px rgba(34,197,94,0); }
`;

/* ── Styles ── */

const Wrapper = styled.section`
  background: #f8fafc;
  padding: 72px 0 80px;
`;

const Inner = styled.div`
  padding: 0 20px;
`;

/* Header */
const HeaderRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: flex-start;
  margin-bottom: 48px;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

const HeaderLeft = styled.div``;

const Eyebrow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.1px;
  text-transform: uppercase;
  color: ${blueColor};
  background: ${blueColor}0f;
  border: 1px solid ${blueColor}28;
  border-radius: 20px;
  padding: 4px 14px;
  margin-bottom: 16px;
`;

const EyebrowDot = styled.span`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: ${goldColor};
`;

const PageTitle = styled.h1`
  font-size: 38px;
  font-weight: 900;
  color: #0a1628;
  letter-spacing: -1.4px;
  line-height: 1.1;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const GoldWord = styled.span`
  color: ${goldColor};
`;

const HeaderRight = styled.div`
  padding-top: 8px;
`;

const HeaderSubline = styled.p`
  font-size: 15px;
  color: #64748b;
  line-height: 1.7;
  margin: 0 0 20px;
`;

const HeaderMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const MetaBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 5px 12px;

  .anticon {
    color: ${blueColor};
    font-size: 12px;
  }
`;

/* ── Bento Grid ── */
const BentoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto auto;
  gap: 20px;

  /* tall card spans rows 1–2, cols 1 */
  & > :nth-child(1) {
    grid-column: 1;
    grid-row: 1 / 3;
  }
  /* normal cards in col 2 */
  & > :nth-child(2) {
    grid-column: 2;
    grid-row: 1;
  }
  & > :nth-child(3) {
    grid-column: 2;
    grid-row: 2;
  }
  /* wide card spans both columns, row 3 */
  & > :nth-child(4) {
    grid-column: 1 / 3;
    grid-row: 3;
  }

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;

    & > :nth-child(1),
    & > :nth-child(2),
    & > :nth-child(3),
    & > :nth-child(4) {
      grid-column: 1;
      grid-row: auto;
    }
  }
`;

/* ── Product Card ── */
const ProductCard = styled.div<{
  $size: "tall" | "normal" | "wide";
  $accent: string;
}>`
  background: #ffffff;
  border: 1px solid #e8f0f8;
  border-radius: 22px;
  overflow: hidden;
  display: flex;
  flex-direction: ${(p) => (p.$size === "wide" ? "row" : "column")};
  transition: all 0.28s ease;
  position: relative;
  cursor: default;

  &:hover {
    box-shadow: 0 16px 48px ${(p) => p.$accent}18;
    border-color: ${(p) => p.$accent}40;
    transform: translateY(-4px);
  }
`;

/* Image */
const CardImageWrap = styled.div<{ $short?: boolean }>`
  position: relative;
  overflow: hidden;
  height: ${(p) => (p.$short ? "160px" : "240px")};
  flex-shrink: 0;
`;

const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.6s ease;

  ${ProductCard}:hover & {
    transform: scale(1.05);
  }
`;

const CardImageGrad = styled.div<{ $accent: string }>`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    transparent 30%,
    ${(p) => p.$accent}28 100%
  );
`;

/* Card body */
const CardBody = styled.div`
  padding: 20px 22px 14px;
  flex: 1;
`;

const CardTagRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const CardTag = styled.div<{ $accent: string }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  color: ${(p) => p.$accent};
  background: ${(p) => p.$accent}12;
  border-radius: 6px;
  padding: 3px 9px;
`;

const CardStat = styled.div<{ $accent: string }>`
  text-align: right;
`;

const CardStatVal = styled.div`
  font-size: 18px;
  font-weight: 900;
  color: #0a1628;
  letter-spacing: -0.5px;
  line-height: 1;
`;

const CardStatLabel = styled.div`
  font-size: 10px;
  color: #94a3b8;
  font-weight: 500;
  margin-top: 1px;
`;

const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 800;
  color: #0a1628;
  letter-spacing: -0.5px;
  margin: 0 0 7px;
  line-height: 1.2;
`;

const CardDesc = styled.p`
  font-size: 13.5px;
  color: #64748b;
  line-height: 1.6;
  margin: 0 0 14px;
`;

const CardBullets = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const CardBullet = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12.5px;
  color: #475569;
  font-weight: 500;
  line-height: 1.4;
`;

const BulletDot = styled.div<{ $accent: string }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${(p) => p.$accent};
  flex-shrink: 0;
  margin-top: 4px;
`;

const CardCta = styled.a<{ $accent: string }>`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  color: ${(p) => p.$accent};
  padding: 14px 22px;
  border-top: 1px solid #f1f5f9;
  text-decoration: none;
  transition:
    gap 0.2s,
    background 0.2s;
  margin-top: auto;

  &:hover {
    gap: 10px;
    background: ${(p) => p.$accent}06;
  }
`;

/* Wide card (Street Parking) */
const WideCardInner = styled.div`
  display: grid;
  grid-template-columns: 420px 1fr;
  width: 100%;
  min-height: 280px;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;

const WideImageWrap = styled.div`
  position: relative;
  overflow: hidden;

  @media (max-width: 860px) {
    height: 200px;
  }
`;

const WideOverlayBadge = styled.div`
  position: absolute;
  top: 16px;
  left: 16px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.22);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 5px 13px;
  font-size: 11.5px;
  font-weight: 600;
  color: #fff;
`;

const BadgePulse = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #22c55e;
  flex-shrink: 0;
  animation: ${pulse} 2s ease-in-out infinite;
`;

const WideContent = styled.div`
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

const WideBulletGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 16px;
  margin-bottom: 16px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

// import React from "react";
// import styled from "styled-components";
// import { Link } from "react-router-dom";
// import { CheckCircle } from "@mui/icons-material";

// import taxesImg from "../../../../../assets/img/paytax.jpg";
// import savingImg from "../../../../../assets/img/saving.jpg";
// import billsImg from "../../../../../assets/img/contactless.jpg";
// import parkingImg from "../../../../../assets/img/parking.jpg";
// import PageHeader from "../PageHeader";

// const products = [
//   {
//     title: "Pay Fees & Taxes",
//     description:
//       "Digitised payment of municipal and local government fees using IRAS PRNs.",
//     image: taxesImg,
//     link: "/products-services/fees-taxes",
//     highlights: [
//       "Municipal & local government payments",
//       "IRAS PRN based reconciliation",
//       "Instant confirmation",
//     ],
//   },
//   {
//     title: "Financial Services",
//     description:
//       "Secure digital payments for SACCO contributions, loan repayments, and withdrawals.",
//     image: savingImg,
//     link: "/products-services/financial-services",
//     highlights: [
//       "SACCO deposits & repayments",
//       "Real-time updates",
//       "Digital receipts",
//     ],
//   },
//   {
//     title: "Pay Bills",
//     description:
//       "Instant settlement of utility and institutional bills with full transparency.",
//     image: billsImg,
//     link: "/products-services/pay-bills",
//     highlights: [
//       "Utilities & institutions",
//       "Real-time bill fetching",
//       "No queues or paperwork",
//     ],
//   },
//   {
//     title: "Street Parking",
//     description:
//       "Cashless street parking payments with real-time enforcement verification.",
//     image: parkingImg,
//     link: "/products-services/street-parking",
//     highlights: [
//       "QR-based parking verification",
//       "Real-time enforcement",
//       "Cashless compliance",
//     ],
//   },
// ];

// export default function ProductsOverview() {
//   return (
//     <>
//       <PageHeader
//         title="OnePayX Products & Services"
//         description="A unified digital payments platform for government, institutions, and everyday services."
//         height="65vh"
//         backgroundImage={savingImg}
//       />

//       <Wrapper data-aos="fade-up" className="container">
//         <Grid>
//           {products.map((product, index) => (
//             <Card key={index}>
//               <ImageWrapper>
//                 <img src={product.image} alt={product.title} />
//               </ImageWrapper>

//               <Content>
//                 <h3>{product.title}</h3>
//                 <p>{product.description}</p>

//                 <Highlights>
//                   {product.highlights.map((item, i) => (
//                     <li key={i}>
//                       <CheckCircle fontSize="small" />
//                       {item}
//                     </li>
//                   ))}
//                 </Highlights>

//                 <StyledLink to={product.link}>View Details →</StyledLink>
//               </Content>
//             </Card>
//           ))}
//         </Grid>
//       </Wrapper>
//     </>
//   );
// }

// const Wrapper = styled.section`
//   padding: 80px 20px;
// `;

// const Grid = styled.div`
//   display: grid;
//   gap: 40px;

//   grid-template-columns: 1fr;

//   @media (min-width: 768px) {
//     grid-template-columns: repeat(2, 1fr);
//   }
// `;

// const Card = styled.div`
//   background: #fff;
//   border-radius: 20px;
//   overflow: hidden;
//   box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
//   transition:
//     transform 0.3s ease,
//     box-shadow 0.3s ease;

//   &:hover {
//     transform: translateY(-6px);
//     box-shadow: 0 30px 60px rgba(0, 0, 0, 0.12);
//   }
// `;

// const ImageWrapper = styled.div`
//   height: 300px;

//   img {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//   }
// `;

// const Content = styled.div`
//   padding: 24px;

//   h3 {
//     font-size: 1.4rem;
//     color: #1b75bb;
//     margin-bottom: 10px;
//   }

//   p {
//     font-size: 0.95rem;
//     color: #555;
//     line-height: 1.6;
//     margin-bottom: 16px;
//   }
// `;

// const Highlights = styled.ul`
//   list-style: none;
//   padding: 0;
//   margin-bottom: 20px;

//   li {
//     display: flex;
//     align-items: center;
//     gap: 8px;
//     font-size: 0.9rem;
//     color: #333;
//     margin-bottom: 8px;

//     svg {
//       color: #1b75bb;
//     }
//   }
// `;

// const StyledLink = styled(Link)`
//   font-weight: 600;
//   color: #1b75bb;
//   text-decoration: none;

//   &:hover {
//     text-decoration: underline;
//   }
// `;
